import { FORMAT_DATE_TEXT_ALT } from '@utils/constants';
import { DateHelper } from '@utils/helpers';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

const ProjectAddEquipmentTime = ({ className, endDate, startDate }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('addEvent-table__info', { className })}>
      <div className="h6">
        <span className="fw600">{t('COMMON.BEGINNING')} </span>
        <span className="h6 color_grey">
          {DateHelper.toFormat(startDate, FORMAT_DATE_TEXT_ALT)}
        </span>
      </div>

      <div className="h6">
        <span className="h6 fw600">{t('COMMON.ENDING')} </span>
        <span className="h6 color_grey">
          {DateHelper.toFormat(endDate, FORMAT_DATE_TEXT_ALT)}
        </span>
      </div>
    </div>
  );
};

export default ProjectAddEquipmentTime;
